import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const RemoveLinkWrapper = styled.div`
  text-align: right;
  a {
    font-size: 12px;
  }
`;

export const AddLinkWrapper = styled.div`
  text-align: left;
  a {
    font-size: 12px;
  }
`;

export const ActionsWrapper = styled.div`
  margin: 24px 0 0;
  display: flex;
  justify-content: flex-end;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${themeGet('colors.black.20')};
  border-radius: 8px;
`;
